import React from 'react'
import Heading from '../../../atoms/Heading/Heading'
import Text from '../../../atoms/Text/Text'

import * as Styled from './PriceListItem.styles'

type PriceListItemProps = {
  title: string
  amount: number
  highlight?: boolean
}

const PriceListItem: React.FunctionComponent<PriceListItemProps> = ({ amount, title, highlight = false }) => (
  <Styled.PriceListItem data-testid="price-list-item" highlight={highlight}>
    <Heading>{title}</Heading>
    <Text size="large">€{amount.toFixed(2).toString().replace('.', ',')}</Text>
  </Styled.PriceListItem>
)

export default PriceListItem
